// IMPORTANT NOTE: if you edit these types you need to `npm run gen-schema`
// to generate api-types-schema.ts.
//
// See also /api-versioning.md.

export const apiVersion = '1.0';
export const apiVersionMinor = parseInt(apiVersion.split('.')[1], 10);

export type CreateCustomerRequest = {
  name: string;
  project?: string;
  email: string;
  commercial: boolean;
  acceptedTOS: boolean;
};

export type CreateCustomerResponse = {
  licenseKey: string;
};

export type GetLicenseStatusRequest = {
  licenseKey: string;
};

export type GetLicenseStatusResponse = {
  status: LicenseStatus;
  disable: boolean;
  pleaseUpdate: boolean;
};

// TODO is there an easy way to share this enum with the db enum,
// without pulling prisma in as a depenedency here?
export enum LicenseStatus {
  Valid = 'VALID',
  Invalid = 'INVALID',
  Unknown = 'UNKNOWN',
}

export type LicenseActiveRequest = {
  licenseKey: string;
  profileID: string;
  // TODO? replicache version?
};

export type LicenseActiveResponse = Record<string, never>;

const apiPath = '/api/' + apiVersion;
const apiRoute = '/api/:apiMajor.:apiMinor';
export const CUSTOMER_PATH = apiPath + '/customer';
export const CUSTOMER_ROUTE = apiRoute + '/customer';
export const LICENSE_STATUS_PATH = apiPath + '/license/status';
export const LICENSE_STATUS_ROUTE = apiRoute + '/license/status';
export const LICENSE_ACTIVE_PATH = apiPath + '/license/active';
export const LICENSE_ACTIVE_ROUTE = apiRoute + '/license/active';

export const ADMIN_PATH = '/admin';
export const ADMIN_DOWNLOAD_PATH = ADMIN_PATH + '/download';
export const ADMIN_LICENSE_PATH = ADMIN_PATH + '/license/:key';
export const ADMIN_LICENSES_ACTIVE_PATH = ADMIN_PATH + '/licenses/active';
export const ADMIN_SIGNUPS_PATH = ADMIN_PATH + '/signups';
export const ADMIN_POPULATE_PATH = ADMIN_PATH + '/populate';
